<template>
	<div class="home">
		<!-- 顶部 -->
		<headerTop />

		<!-- 左侧导航栏开始 -->
		<el-row class="tac">
			<el-col :span="3" class="homelfnav">
				<!-- :router="true"启用该模式会在激活导航时以 index 作为 path 进行路由跳转 -->
				<!-- <el-menu
		:router="true"
	      :default-active="defaultactive"
	      class="el-menu-vertical-demo"
	      @open="handleOpen"
	      @close="handleClose">
	      <el-submenu v-for="(item,index) in navArr" :index="index+''">
	        <template slot="title">
	          <i class="el-icon-menu"></i>
	          <span>{{item.navname}}</span>
	        </template>
<el-menu-item-group>
	<el-menu-item v-for="(childitem,childindex) in item.navchild" :index="navPath[index][childindex]">
		<i :class="navicon[childindex]"></i>{{childitem}}
	</el-menu-item>
</el-menu-item-group>
</el-submenu>
</el-menu>-->
				<div class="lfnav">
					<p class="lftit"><i class="el-icon-menu"></i>菜单栏</p>
					<ul class="lfnavul">
						<li @click="navclick(childitem, childindex)"
							v-for="(childitem, childindex) in navArr[0].navchild"
							:class="flagindex == childindex ? 'lfnavulactive' : ''">
							<i :class="navicon[childindex]"></i>
							<span>{{ childitem }}</span>
						</li>
					</ul>
				</div>



			</el-col>

		</el-row>
		<!-- 左侧导航栏结束-->

		<el-row class="tac">
			<el-col :span="2">&nbsp;</el-col>
			<el-col :span="21" class="homertnav">
				<!-- 右侧 -->
				<router-view />
			</el-col>
		</el-row>

	</div>
</template>

<script>
// @ is an alias to /src
import headerTop from '@/components/header.vue'
import * as IndexAPI from '@/services/index'
export default {
	name: 'Home',
	components: {
		headerTop
	},
	data() {
		return {
			userinfor: {},
			flagindex: null,
			//默认展开的页面路径
			defaultactive: '',
			navPath: [
				['/index/task', '/index/statistical', '/index/lineSet'],
				['/index/mycustomer', '/index/customersea'],
			],
			navicon: ['el-icon-s-help', 'el-icon-collection', 'el-icon-s-custom', 'el-icon-collection', 'el-icon-s-tools', 'el-icon-upload', 'el-icon-setting'],
			navArr: [{
				navname: '菜单栏',
				navchild: ['外呼任务', '通话记录']
			}]
		}
	},
	mounted() {
		//获取用户信息
		let UserInfor = localStorage.getItem('userInfor')
		if (UserInfor) {
			this.userinfor = JSON.parse(UserInfor)
			// purview,0:管理员  1:普通 3：超级管理员
			if (this.userinfor.purview == 0) {
				this.navArr = [{
					navname: '菜单栏',
					navchild: ['外呼任务', '通话记录', '线路分配', 'VIP名单']
				}]
			} else if (this.userinfor.purview == 1) {
				this.navArr = [{
					navname: '菜单栏',
					navchild: ['外呼任务', '通话记录',]
				}]
			} else if (this.userinfor.purview == 3) {
				this.navArr = [{
					navname: '菜单栏',
					navchild: ['外呼任务', '通话记录', '线路分配', 'VIP名单', '人员设置','同步数据']
				}]
			}
		}

		//console.log('home页用户信息',this.userinfor)
		//默认展开
		if (window.location.hash == '#/index/statistical') {
			this.defaultactive = '/index/statistical'
		}
		if (window.location.hash == '#/index/task') {
			this.defaultactive = '/index/task'
		}
		if (window.location.hash == '#/index/mycustomer') {
			this.defaultactive = '/index/mycustomer'
		}
		if (window.location.hash == '#/index/customersea') {
			this.defaultactive = '/index/customersea'
		}

		if (window.location.hash == '#/index/lineSet') {
			this.defaultactive = '/index/lineSet'
		}
		if (window.location.hash == '#/index/callLog') {
			this.defaultactive = '/index/callLog'
		}
		if (window.location.hash == '#/index/callHistoryPersion') {
			this.defaultactive = '/index/callHistoryPersion'
		}
		if (window.location.hash == '#/index/setvip') {
			this.defaultactive = '/index/setvip'
		}
		if (window.location.hash == '#/index/setting') {
			this.defaultactive = '/index/setting'
		}
		if (window.location.hash == '#/index/synchronize') {
			this.defaultactive = '/index/synchronize'
		}



	},
	watch: {
		"$route.path": {
			immediate: true,
			handler(val) {
				// console.log('val',val)
				//当路由变化时更改导航栏的样式
				
				if (val == '/index/task') {
					this.flagindex = 0
				} else if (val == '/index/callHistoryPersion') {
					this.flagindex = 1
				} else if (val == '/index/lineSet') {
					this.flagindex = 2
				} else if (val == '/index/setvip') {
					this.flagindex = 3
				} else if (val == '/index/setting') {
					this.flagindex = 4
				}  else if (val == '/index/synchronize') {
					this.flagindex = 5
				}

			}
		}

	},
	methods: {
		navclick(name, index) {
			this.flagindex = index

			if (name == '外呼任务' && window.location.hash != '#/index/task') {
				this.$router.push('/index/task');

			} else if (name == '外呼统计' && window.location.hash != '#/index/statistical') {
				this.$router.push('/index/statistical');

			} else if (name == '线路分配' && window.location.hash != '#/index/lineSet') {
				this.$router.push('/index/lineSet');

			}else if (name == '通话记录' && window.location.hash != '#/index/callHistoryPersion') {
				this.$router.push('/index/callHistoryPersion');

			} else if (name == 'VIP名单' && window.location.hash != '#/index/setvip') {
				this.$router.push('/index/setvip');

			}else if (name == '人员设置' && window.location.hash != '#/index/setting') {
				this.$router.push('/index/setting');

			}else if (name == '同步数据' && window.location.hash != '#/index/synchronize') {
				this.$router.push('/index/synchronize');
			
			}
		},
		handleOpen() {

		},
		handleClose() {

		}
	}
}
</script>

<style scoped lang="scss">
.homelfnav {
	position: fixed;
	left: 0;
	top: 120px;
	height: 100%;

	::v-deep .el-menu {
		height: 100%;
	}

	::v-deep .el-submenu {
		border-bottom: 1px solid #f5f5f5;
		margin-top: 20px;
	}

	::v-deep .el-submenu__title {
		font-size: 16px;
	}

	// 隐藏导航的折叠按钮
	::v-deep .el-submenu__icon-arrow {
		display: none;
	}
}

.homertnav {
	margin-top: 60px;
}

.lfnav {
	text-align: center;
	width: 100%;
	border-right: 1px solid #e9e6e6;
	height: 80%;
}

.lftit {
	font-size: 18px;
	box-sizing: border-box;
	padding: 20px 0;
	color: #666;
	font-weight: bold;
}

.lftit i {
	margin-right: 10px;
}

.lfnavul li {
	line-height: 40px;
	font-size: 16px;
	border-top: 1px solid #f5f5f5;

	i {
		margin-right: 5px;
	}

	cursor: pointer;
	padding: 10px 0;


}

.lfnavul li:hover {
	background-color: #f6f5ff;
}

.lfnavulactive {
	background-color: #f6f5ff;

	i {
		color: #9282fc;
	}
}
</style>